import { Tooltip, Typography, alpha } from '@mui/material';
import { useIntl } from 'react-intl';

/**
 * Compact pill chip rendering a structure's prescribed target dose
 * (Gy). Used to mark target ROIs in the structure list and the dose
 * statistics table. Includes a tooltip explaining where the value
 * comes from so clinicians can trust the displayed quantity.
 */
const TargetDoseBadge = ({
    doseQuantityGy,
    structureName,
    fontSize = 11,
}: {
    doseQuantityGy: number;
    structureName: string;
    fontSize?: number;
}) => {
    const intl = useIntl();
    return (
        <Tooltip
            title={intl.formatMessage({ id: 'targetDoseBadgeTooltip' })}
            placement="top"
        >
            <Typography
                component="span"
                variant="body2"
                fontSize={fontSize}
                fontWeight={500}
                data-testid={`target-dose-badge-${structureName}`}
                sx={(theme) => ({
                    color: theme.palette.primary.main,
                    backgroundColor: alpha(theme.palette.primary.main, 0.1),
                    borderRadius: 0.5,
                    px: 0.5,
                    lineHeight: 1.4,
                    whiteSpace: 'nowrap',
                })}
            >
                {doseQuantityGy.toFixed(1)} Gy
            </Typography>
        </Tooltip>
    );
};

export default TargetDoseBadge;
